/* Moomo R2 · green "Added to cart" confirmation in the cart drawer (aria-live). */
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  const check = '<svg viewBox="0 0 18 18" width="18" height="18" aria-hidden="true"><circle cx="9" cy="9" r="9" fill="#272323"/><path d="M5.2 9.3l2.4 2.4 5.2-5.2" fill="none" stroke="#fff9f2" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const insert = (text) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    let tries = 0;
    const tick = () => {
      const header = drawer.querySelector('.drawer__header');
      if (!drawer.classList.contains('active') || !header) { if (tries++ < 40) setTimeout(tick, 50); return; }
      drawer.querySelector('.mm-added')?.remove();
      const bar = document.createElement('div');
      bar.className = 'mm-added';
      bar.setAttribute('role', 'status');
      bar.setAttribute('aria-live', 'polite');
      bar.innerHTML = `${check}<span></span>`;
      bar.querySelector('span').textContent = text;
      header.insertAdjacentElement('afterend', bar);
    };
    setTimeout(tick, 60);
  };
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || event.source !== 'product-form' || !event.cartData) return;
    const item = event.cartData.items ? event.cartData.items[0] : event.cartData;
    if (!item || !item.product_title) return;
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` · ${item.variant_title}` : '';
    insert(`Added to cart: ${item.product_title}${variant}`);
  });
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(() => { if (!drawer.classList.contains('active')) drawer.querySelector('.mm-added')?.remove(); }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
